import { TListResponse } from 'src/common/types';
import { TTableSort, TTableSortCols } from 'src/components/table/thead/col';
import { TUserMeta, TUserMetaResponse, adaptUserMetaUndefinedFromResponse } from './user-meta.type';


export const BrandListSortCol = {
	NAME: 'name',
	UPDATED_AT: 'updated_at',
	CREATED_AT: 'created_at',
};

export type TBrandListSortCol = TTableSortCols<typeof BrandListSortCol>;

export type TBrandListQuery = {
	limit: number;
	offset: number;
	search?: string;
	sort?: TTableSort;
	sortCol?: TBrandListSortCol;
};

export type TBrandListQueryRequest = {
	limit?: number;
	offset?: number;
	search?: string;
	sort?: string;
	sort_col?: string;
};

export function adaptBrandListQueryToRequest(data?: TBrandListQuery): TBrandListQueryRequest {
	if (!data) {
		return {};
	}

	const {
		sortCol,
		...restFields
	} = data;

	return {
		sort_col: sortCol,
		...restFields
	};
}

export type TBrand = {
  id: number;
  name: string;
  description?: string;
	createdAt: string;
  updatedAt: string;

	createdBy?: TUserMeta;
	updatedBy?: TUserMeta;
};

export type TBrandResponse = {
  id: number;
  name: string;
  description?: string;
  created_at: string;
  updated_at: string;

	created_by?: TUserMetaResponse;
	updated_by?: TUserMetaResponse;
};

export type TBrandListResponse = TListResponse<TBrandResponse>;

export type TBrandList = TListResponse<TBrand>;

export type TBrandPayloadRequest = {
	name: string;
	description?: string;
};

export type TBrandRequest = {
	name: string;
	description?: string;
};

export type TBrandPayloadUpdate = {
	id: number;
	data: TBrandPayloadRequest;
};

export function adaptBrandFromListResponse(data: TBrandListResponse): TBrandList {
	const {
		items: itemsRaw = [],
		...restFields
	} = data;

	const items = itemsRaw.map(item => adaptBrandFromResponse(item));

	return {
		items,
		...restFields
	};
}

export function adaptBrandFromResponse(data: TBrandResponse): TBrand {
	const {
		id,
		name,
		description,
		created_at: createdAt,
		updated_at: updatedAt,
		created_by: createdByRaw,
		updated_by: updatedByRaw,
	} = data;

	const createdBy = adaptUserMetaUndefinedFromResponse(createdByRaw);
	const updatedBy = adaptUserMetaUndefinedFromResponse(updatedByRaw);

	return {
		id,
		name,
		description,
		createdAt,
		updatedAt,
		createdBy,
		updatedBy,
	};
}

export function adaptBrandToRequest(data: TBrandPayloadRequest): TBrandRequest {
	const {
		name,
		description = undefined,
	} = data;

	return {
		name,
		description,
	};
}
